var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72039 11.8864C2.50179 11.105 3.5616 10.666 4.66667 10.666H11.3333C12.4384 10.666 13.4982 11.105 14.2796 11.8864C15.061 12.6678 15.5 13.7276 15.5 14.8327V16.4994C15.5 16.9596 15.1269 17.3327 14.6667 17.3327C14.2064 17.3327 13.8333 16.9596 13.8333 16.4994V14.8327C13.8333 14.1696 13.5699 13.5338 13.1011 13.0649C12.6323 12.5961 11.9964 12.3327 11.3333 12.3327H4.66667C4.00363 12.3327 3.36774 12.5961 2.8989 13.0649C2.43006 13.5338 2.16667 14.1696 2.16667 14.8327V16.4994C2.16667 16.9596 1.79357 17.3327 1.33333 17.3327C0.873096 17.3327 0.5 16.9596 0.5 16.4994V14.8327C0.5 13.7276 0.938987 12.6678 1.72039 11.8864Z",
    fill: "#2295D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.33268C6.61929 2.33268 5.5 3.45197 5.5 4.83268C5.5 6.2134 6.61929 7.33268 8 7.33268C9.38071 7.33268 10.5 6.2134 10.5 4.83268C10.5 3.45197 9.38071 2.33268 8 2.33268ZM3.83333 4.83268C3.83333 2.5315 5.69881 0.666016 8 0.666016C10.3012 0.666016 12.1667 2.5315 12.1667 4.83268C12.1667 7.13387 10.3012 8.99935 8 8.99935C5.69881 8.99935 3.83333 7.13387 3.83333 4.83268Z",
    fill: "#2295D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.4efb098cb13942b976309b9f73fb511e.svg";
export { ForwardRef as ReactComponent };